import { render, staticRenderFns } from "./PurPL.vue?vue&type=template&id=4f7a77c3"
import script from "./PurPL.vue?vue&type=script&lang=js"
export * from "./PurPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports